import { render, staticRenderFns } from "./ProjectServiceDashboard.vue?vue&type=template&id=277ca2ae&"
import script from "./ProjectServiceDashboard.vue?vue&type=script&lang=ts&"
export * from "./ProjectServiceDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectServiceDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports